const createImage = url =>
    new Promise((resolve, reject) => {
        const image = new Image();
        image.addEventListener('load', () => resolve(image));
        image.addEventListener('error', error => reject(error));
        image.src = url;
    });

const getRadianAngle = (degreeValue) => {
    return (degreeValue * Math.PI) / 180;
}

const rotateSize = (width, height, rotation) => {
    const rotRad = getRadianAngle(rotation);

    return {
        width: Math.abs(Math.cos(rotRad) * width) + Math.abs(Math.sin(rotRad) * height),
        height: Math.abs(Math.sin(rotRad) * width) + Math.abs(Math.cos(rotRad) * height)
    };
}

async function getCroppedImg(
    imageSrc,
    pixelCrop,
    rotation = 0,
    flip = { horizontal: false, vertical: false }
) {
    const image = await createImage(imageSrc);
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d', { alpha: true });

    if (!ctx) {
        return null;
    }

    const rotRad = getRadianAngle(rotation);

    // calculate bounding box of the rotated image
    const { width: bBoxWidth, height: bBoxHeight } = rotateSize(
        image.width,
        image.height,
        rotation
    );

    // set canvas size to match the bounding box
    canvas.width = bBoxWidth;
    canvas.height = bBoxHeight;

    // translate canvas context to a central location to allow rotating and flipping around the center
    ctx.translate(bBoxWidth / 2, bBoxHeight / 2);
    ctx.rotate(rotRad);
    ctx.scale(flip.horizontal ? -1 : 1, flip.vertical ? -1 : 1);
    ctx.translate(-image.width / 2, -image.height / 2);
    // draw rotated image
    ctx.drawImage(image, 0, 0);

    // croppedAreaPixels values are bounding box relative
    // extract the cropped image using these values
    const data = ctx.getImageData(pixelCrop.x, pixelCrop.y, pixelCrop.width, pixelCrop.height);

    // set canvas width to final desired crop size - this will clear existing context
    canvas.width = pixelCrop.width;
    canvas.height = pixelCrop.height;

    // paste generated rotate image at the top left corner
    ctx.putImageData(data, 0, 0);

    // return image Base64
    let imageBase64 = canvas.toDataURL('image/png');
    let stringLength = imageBase64.length - 'data:image/png;base64,'.length;
    let imageSize = Math.round(4 * Math.ceil(stringLength / 3) * 0.5624896334383812);
    var file = getFileFromBase64(imageBase64, 'image.jpeg');

    return {
        name: 'image.jpeg',
        type: 'image/jpeg',
        size: imageSize,
        image: imageBase64,
        file: file
    };
}

const checkValidImage = inputImage => {
    return new Promise((resolve, reject) => {
        let image = new Image();
        image.src = inputImage;
        image.onload = () => {
            resolve(image);
        };
        image.onerror = reject;
    });
};

const getFileFromBase64 = (string64, fileName) => {
    const trimmedString = string64.replace('data:image/jpeg;base64,', '').replace(/^[^,]+,/, '');
    const imageContent = window.atob(trimmedString);
    const buffer = new ArrayBuffer(imageContent.length);
    const view = new Uint8Array(buffer);
  
    for (let n = 0; n < imageContent.length; n++) {
      view[n] = imageContent.charCodeAt(n);
    }
    const type = 'image/jpeg';
    const blob = new Blob([buffer], { type });
    return new File([blob], fileName, { lastModified: new Date().getTime(), type });
  }


// /**
//  * @param {File} imageSrc -Image File url
//  * @param {Object} pixelCrop - pixelCrop Object provided by react-easy-crop
//  */
// async function getCroppedImg(imageSrc, pixelCrop) {
//     const image = await createImage(imageSrc);

//     const canvas = document.createElement('canvas');
//     const ctx = canvas.getContext('2d');

//     const maxSize = Math.max(image.width, image.height);
//     const safeArea = 2 * ((maxSize / 2) * Math.sqrt(2));

//     // set each dimensions to double largest dimension to allow for a safe area for the
//     // image to rotate in without being clipped by canvas context
//     canvas.width = safeArea;
//     canvas.height = safeArea;

//     // translate canvas context to a central location on image to allow rotating around the center.
//     ctx.translate(safeArea / 2, safeArea / 2);
//     ctx.translate(-safeArea / 2, -safeArea / 2);

//     // draw rotated image and store data.
//     ctx.drawImage(image, safeArea / 2 - image.width * 0.5, safeArea / 2 - image.height * 0.5);
//     const data = ctx.getImageData(0, 0, safeArea, safeArea);

//     // set canvas width to final desired crop size - this will clear existing context
//     canvas.width = pixelCrop.width;
//     canvas.height = pixelCrop.height;

//     // paste generated rotate image with correct offsets for x,y crop values.
//     ctx.putImageData(
//         data,
//         Math.round(0 - safeArea / 2 + image.width * 0.5 - pixelCrop.x),
//         Math.round(0 - safeArea / 2 + image.height * 0.5 - pixelCrop.y)
//     );

//     // return image Base64
//     let imageBase64 = canvas.toDataURL('image/jpeg');
//     var stringLength = imageBase64.length - 'data:image/png;base64,'.length;
//     let imageSize = Math.round(4 * Math.ceil((stringLength / 3))*0.5624896334383812);

//     return {
//         name: "image.jpeg",
//         type: "image/jpeg",
//         size: imageSize,
//         image: imageBase64
//     };
// }

const CropImageUtil = {
    getCroppedImg,
    checkValidImage
};

export default CropImageUtil;
